import { Navigate } from 'react-router-dom';

/** Legacy route — cashier is the canonical wallet UX. */
export function WalletPage() {
  return <Navigate to="/cashier" replace />;
}
